import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import classnames from 'classnames';

import style from './index.scss';

const AsigneeModal = ({
  isShown,
  data,
  toggleAssignModal,
  onAssignConfirm
}) => {
  if (!isShown) {
    return <div />;
  }

  let investigatorList = [];
  data.forEach((investor, i) => {
    investigatorList.push(
      <div className="custom-radio" key={investor.name}>
        <input
          type="radio"
          name="assignee"
          id={'radio' + i}
          className="css-radio"
          onChange={(e) => {}}
          defaultChecked={i == 0}
        />
        <label
          htmlFor={'radio' + i}
          className={classnames('css-radio-label', style.hoverText)}
          style={
            investor.isStaff
              ? { borderColor: '#2196F3', backgroundColor: '#ddffff' }
              : {}
          }>
          {investor.name}
          {investor.isStaff ? (
            <p className={style.hint}>Investigates this customer already</p>
          ) : null}
        </label>
      </div>
    );
  });

  return (
    <Modal isOpen={isShown} toggle={() => toggleAssignModal()}>
      <ModalBody>
        <p>Choose an investigator</p>
        <Scrollbars style={{ height: 240 }}>{investigatorList}</Scrollbars>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-tertiary"
          onClick={(e) => toggleAssignModal(e)}>
          Cancel
        </button>{' '}
        <button className={style.actionBtn} onClick={(e) => onAssignConfirm(e)}>
          Yes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AsigneeModal;
